import { ComponentProps } from 'react';

export function ClapperboardPlay({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="32"
      height="28"
      viewBox="0 0 32 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 0H4C1.79063 0 0 1.79063 0 4V24C0 26.2094 1.79063 28 4 28H28C30.2094 28 32 26.2094 32 24V4C32 1.79063 30.2062 0 28 0ZM15.8813 3H20.1238L15.1237 8H10.8813L15.8813 3ZM3 5.88125L5.87875 3H10.1213L5.12125 8H3V5.88125ZM29 24C29 24.5514 28.5514 25 28 25H4C3.44863 25 3 24.5514 3 24V11H29V24ZM29 4.12125L25.1187 8H20.8762L25.8762 3H28C28.5514 3 29 3.44863 29 4V4.12125ZM13.6687 23C13.7912 23 13.9149 22.965 14.0216 22.8949L20.6904 18.5842C20.8812 18.4562 21 18.2375 21 17.9438C21 17.65 20.8815 17.485 20.6862 17.3591L14.0174 13.0485C13.8188 12.9688 13.5562 12.9688 13.3438 13.0875C13.1313 13.2062 13 13.4375 13 13.6875V22.3062C13 22.5567 13.1315 22.7878 13.3438 22.9097C13.4438 22.9688 13.5562 23 13.6687 23Z"
        fill="currentColor"
      />
    </svg>
  );
}
